// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3JuH0{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;background:#ededee;border-radius:6px;color:#010101;height:120px;justify-content:space-between;padding:13px}._3JuH0 h1{font-size:20px;font-weight:800;line-height:27px}._3JuH0 div:has(>span){text-align:right}._3JuH0 span{font-size:17px;font-weight:350;line-height:23px}._29fXJ{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;height:100%}", ""]);
// Exports
exports.locals = {
	"KPIsContainter": "_3JuH0",
	"KPIs": "_29fXJ"
};
module.exports = exports;
